import { render, staticRenderFns } from "./optionUserCurrency.vue?vue&type=template&id=3800f01e"
import script from "./optionUserCurrency.vue?vue&type=script&lang=js"
export * from "./optionUserCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports